import type { GalleryModel, ValidationStatus } from '@/components/ProductCard/types'
import { useTranslation } from 'react-i18next'
import { DataFallback } from './DataFallback'
import { ModelValidationStatus } from './ModelValidationStatus'
import { ProductBrand } from './ProductBrand'
import { ProductComposition } from './ProductComposition'
import { ProductNature } from './ProductNature'
import { SizeVariations } from './SizeVariations'
import { displayGenders, sortSizeVariants } from './utils'
import './model-compo-variations.scss'

export function ModelCompoVariations({
  productModel,
  showBrand = true,
  showSizes = true,
  showGender = true,
  showProductNature = true,
  showComposition = true,
  showValidationStatus = true,
}: Readonly<{
  productModel: GalleryModel
  showSizes?: boolean
  showBrand?: boolean
  showGender?: boolean
  showProductNature?: boolean
  showComposition?: boolean
  showValidationStatus?: boolean
}>) {
  const { t } = useTranslation()

  return (
    <section
      className="model-card-compo-variations"
      data-testid="model-card_compo-variations"
    >
      {showBrand && (
        <ProductBrand id={productModel.brand?.id.toString()} />
      )}
      {showSizes && (
        <SizeVariations
          sizes={sortSizeVariants(productModel.variants.filter(variant => variant.status === 'ACTIVE'))}
        />
      )}
      {showGender && (
        <div className="model-gender" data-testid="model_gender">
          <span className="sr-only">
            {t('products-page.filters.groups.genders')}
            :
            {' '}
          </span>
          <DataFallback
            value={productModel.genders}
            fallbackKey="products-page.product-card.no-gender"
            isEmpty={items => items.length === 0}
          >
            {genders => displayGenders(genders, t)}
          </DataFallback>
        </div>
      )}
      {showProductNature && (
        <ProductNature id={productModel.product_nature?.id} />
      )}
      {showComposition && (
        <ProductComposition composition={productModel.composition} />
      )}
      {showValidationStatus && (
        <ModelValidationStatus validationStatus={productModel.validation_status as ValidationStatus} />
      )}
    </section>
  )
}
